import { mutateByPath } from "../../../utility";
import {
  ArsContextState,
  ArsStateUpdate,
  IArsActionPatchArsStateMultiple,
  IArsActionPatchArsStateSingle,
} from "../interface";
import { addPatchToStack } from "./arsc_patchHelpers";

/**
 * Applies one or more JSON-pointer updates atomically.
 *
 * @param state - Current ARS context state
 * @param action - Patch-state action
 * @returns Updated state with patches recorded
 */
export const arsc_patchArsState = <T>(
  state: ArsContextState<T>,
  action: IArsActionPatchArsStateSingle | IArsActionPatchArsStateMultiple,
): ArsContextState<T> => {
  let newState = state;
  const updates: ArsStateUpdate[] = "updates" in action ? action.updates : [action];

  for (const update of updates) {
    newState = mutateByPath(newState, update.dataPath, update.value);
  }

  return addPatchToStack(state, {
    ...newState,
    changed: true,
  });
};
